import React from 'react';
import { withRouter } from 'react-router';
import { Translation } from 'react-i18next';
import Logger from '../../../../../lib/Logger';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography, Select, Tooltip } from 'antd';
import { PublicStatusTag } from '../../../elements/components/Tags';
import {
  faGripVertical,
  faPenToSquare,
} from '@fortawesome/free-solid-svg-icons';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import imageLoading from './../../../assets/images/image-loading.png';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import useFetchSignedUrl from '../../../hooks/useFetchSignedUrl';
import { pathTo } from '../../../Routes';
import QueryString from '../../../../../lib/QueryString';
import { EyeOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const optionsPublicStatus = [1, 2, 3];

const LearningAdminModuleCard = ({
  item,
  handleValue,
  handleOpenConfirmationModal,
  getSignedUrl,
  imageUrl,
  setActiveImage,
  imagePath,
  history,
  partnershipId,
  view,
  activeKey,
  showDetail,
  ...props
}) => {
  const editModule = () => {
    history.push(
      QueryString.append(
        pathTo('LearningAdminModuleEditScreen', {
          id_partnership: partnershipId,
          id: item.id,
        }),
        { view, key: activeKey }
      )
    );
  };

  useFetchSignedUrl(imagePath, imageUrl, getSignedUrl, setActiveImage);

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: 'grab',
    backgroundColor: isDragging ? '#E3F2FD' : '#FFFFFF',
  };

  return (
    <Translation>
      {(t) => (
        <>
          <div
            ref={setNodeRef}
            style={style}
            {...attributes}
            {...listeners}
            className='module-card'
          >
            <div className='module-card-header'>
              <FontAwesomeIcon icon={faGripVertical} />
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Select
                  defaultValue={item.public_status}
                  bordered={false}
                  showArrow={true}
                  placement='bottomRight'
                  onChange={(value) => handleValue(item.id, value)}
                  onPointerDown={(e) => e.stopPropagation()}
                  style={{
                    width: 'auto',
                    minWidth: '60px',
                  }}
                >
                  {optionsPublicStatus.map((x) => (
                    <Select.Option
                      key={x}
                      value={x}
                      style={{
                        textAlign: 'center',
                      }}
                    >
                      <PublicStatusTag value={x} />
                    </Select.Option>
                  ))}
                </Select>
                <EyeOutlined
                  onPointerDown={(e) => e.stopPropagation()}
                  className='module-action-icon-preview'
                  style={{
                    marginRight: '10px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    showDetail(item.id);
                  }}
                />
                {item.public_status === 3 ? (
                  <FontAwesomeIcon
                    onPointerDown={(e) => e.stopPropagation()}
                    onClick={() => {
                      handleOpenConfirmationModal(item.id);
                    }}
                    icon={faTrashCan}
                    className='cursor-pointer module-action-icon-delete'
                  />
                ) : (
                  <Tooltip
                    placement='topRight'
                    title={t('learning_module_series_message_info_delete')}
                    arrowPointAtCenter={true}
                  >
                    <FontAwesomeIcon
                      onPointerDown={(e) => e.stopPropagation()}
                      icon={faTrashCan}
                      className='module-action-icon-delete-disabled'
                    />
                  </Tooltip>
                )}

                <FontAwesomeIcon
                  onPointerDown={(e) => e.stopPropagation()}
                  icon={faPenToSquare}
                  className='module-action-icon-edit cursor-pointer'
                  onClick={(e) => editModule()}
                />
              </div>
            </div>

            <div
              className='cursor-pointer module-card-image-wrapper'
              onPointerDown={(e) => e.stopPropagation()}
              onClick={(e) => editModule()}
            >
              <img
                alt='media-module'
                src={imageUrl ?? imageLoading}
                className='module-card-image'
              />
            </div>

            <Title
              className='cursor-pointer'
              onPointerDown={(e) => e.stopPropagation()}
              level={4}
              ellipsis={true}
              style={{ marginTop: '12px' }}
              onClick={(e) => editModule()}
            >
              {item.title}
            </Title>
            <Paragraph
              style={{ marginTop: '12px' }}
              ellipsis={{
                rows: 5,
              }}
            >
              {item.description}
            </Paragraph>
          </div>
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningAdminModuleCard);

Logger.log('silly', `LearningAdminModuleCard loaded.`);
